
export default {
  props: {
    languages: {
      type: Object,
      default: () => {}
    }
  }
}
